import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { SpaceBetweenRowContainer, FlexEndContainer, FlexColumn } from '../styles/Containers'
import BodyText from '../styles/Text'
import SentBillRow from './SentBillRow'

const Empty = styled(BodyText)`
  display: flex;
  justify-content: center;
  padding-top: 15px;
`

const Headings = styled(SpaceBetweenRowContainer)`
  padding: 0px 30px;
  align-self: stretch;
  margin-right: 47px;
`

const Item = styled.div`
  flex-basis: 16%;
  font-size: 16px;
`

const LastItem = styled(FlexEndContainer)`
  min-width: 120px;
`

const Placeholder = styled.div`
  width: 29px;
`

function SentBillTable({ bills, requestorEmail = '', onBillUpdate = () => {} }) {
  return (
    <FlexColumn gap="15px">
      <Headings>
        <Item>ID</Item>
        <Item>Type</Item>
        <Item>Amount</Item>
        <Item>Date Sent</Item>
        <Item>Date Completed</Item>
        <Item>Method</Item>
        <LastItem>Status</LastItem>
        <Placeholder />
      </Headings>

      {bills && bills.length > 0 ? (
        bills.map(bill => <SentBillRow key={bill.id} bill={bill} requestorEmail={requestorEmail} onBillUpdate={onBillUpdate} />)
      ) : (
        <Empty>No bills available</Empty>
      )}
    </FlexColumn>
  )
}

SentBillTable.propTypes = {
  bills: PropTypes.array.isRequired,
  requestorEmail: PropTypes.string,
  onBillUpdate: PropTypes.func
}

export default SentBillTable
